import { render, staticRenderFns } from "./SchemaSaveAsDialog.vue?vue&type=template&id=2f488ec9&scoped=true"
import script from "./SchemaSaveAsDialog.vue?vue&type=script&lang=js"
export * from "./SchemaSaveAsDialog.vue?vue&type=script&lang=js"
import style0 from "./SchemaSaveAsDialog.vue?vue&type=style&index=0&id=2f488ec9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f488ec9",
  null
  
)

export default component.exports